/**
 * Product Ranking Tracker
 * Tracks client-side interactions and exposes scores for grid reordering.
 * Loaded globally from theme.liquid.
 *
 * Signals:
 *   carts       +12 each (max 24)    — product found in cart on page load
 *   cartRemoved -9 each              — product was in cart, now gone
 *   wishlist    +10 if active         — wishlisted via Wishlist Hero
 *   wishlistRm  -9 each              — removed from wishlist
 *   time        +5 if >30s           — time spent on product page
 *   views       +1 each (max 4)      — product page visits
 */
(function () {
  'use strict';

  var KEY = 'product-ranking';
  var CART_KEY = 'product-ranking-cart';
  var MAX_AGE = 30 * 86400000;

  function load(k) {
    try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; }
  }
  function save(k, v) {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }

  var data = load(KEY) || {};

  function product(id) {
    id = String(id);
    if (!data[id]) data[id] = { carts: 0, cartRemoved: 0, wishlist: false, wishlistRm: 0, views: 0, time: 0, lastSeen: 0 };
    if (data[id].cartRemoved === undefined) data[id].cartRemoved = 0;
    if (data[id].wishlistRm === undefined) data[id].wishlistRm = 0;
    data[id].lastSeen = Date.now();
    return data[id];
  }

  function persist() { save(KEY, data); }

  // ── Clean old data ─────────────────────────────────────
  var cutoff = Date.now() - MAX_AGE;
  for (var id in data) {
    if (data[id].lastSeen && data[id].lastSeen < cutoff) delete data[id];
  }
  persist();

  // ── 1. Track product page views ────────────────────────
  if (/\/products\//.test(location.pathname)) {
    var meta = document.querySelector('meta[property="product:id"]');
    if (meta) {
      product(meta.content).views++;
      persist();
    }
  }

  // ── 2. Track cart — poll on every page load ────────────
  // Instead of intercepting fetch/XHR (unreliable with 3rd-party apps),
  // we compare the current cart with what we saw last time.
  (function trackCart() {
    var previousCart = load(CART_KEY) || {}; // { productId: true, ... }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        var currentCart = {};
        cart.items.forEach(function (item) {
          currentCart[String(item.product_id)] = true;
        });

        // New in cart (wasn't there last time) → cart add
        for (var pid in currentCart) {
          if (!previousCart[pid]) {
            var p = product(pid);
            p.carts++;
            persist();
          }
        }

        // Was in cart last time but gone now → cart removal
        for (var pid2 in previousCart) {
          if (!currentCart[pid2]) {
            var p2 = product(pid2);
            p2.cartRemoved++;
            persist();
          }
        }

        // Save current cart for next page load comparison
        save(CART_KEY, currentCart);
      })
      .catch(function () {});
  })();

  // ── 3. Track wishlist (add + remove) ───────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wlh-id], .wishlist-btn, .wishlist-hero-custom-button');
    if (!btn) return;
    var card = btn.closest('[data-product-id]');
    var wlhId = btn.dataset ? btn.dataset.wlhId : null;
    var id = card ? card.dataset.productId : wlhId;
    if (!id) return;
    var p = product(id);
    if (p.wishlist) {
      p.wishlist = false;
      p.wishlistRm++;
    } else {
      p.wishlist = true;
    }
    persist();
  }, true);

  // ── 4. Track time on product page ──────────────────────
  if (/\/products\//.test(location.pathname)) {
    var timeMeta = document.querySelector('meta[property="product:id"]');
    if (timeMeta) {
      var timeId = timeMeta.content;
      var start = Date.now();
      var saved = false;

      function record() {
        if (saved) return;
        var secs = Math.round((Date.now() - start) / 1000);
        if (secs < 3) return;
        saved = true;
        product(timeId).time += secs;
        persist();
      }

      window.addEventListener('beforeunload', record);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) record();
      });
    }
  }

  // ── Score calculator ───────────────────────────────────
  function getScore(productId) {
    var p = data[String(productId)];
    if (!p) return 0;
    var score = 0;
    score += Math.max(Math.min(p.carts * 12, 24) - (p.cartRemoved || 0) * 9, 0);
    score += Math.max((p.wishlist ? 10 : 0) - (p.wishlistRm || 0) * 9, 0);
    score += p.time > 30 ? 5 : 0;
    score += Math.min(p.views, 4);
    return score;
  }

  // ── Public API ─────────────────────────────────────────
  window.productRanking = {
    getScore: getScore,
    getData: function () { return data; }
  };
})();
